import JobAlertChip from '@/modules/JobAlerts/components/JobAlertChip/JobAlertChip';
import { IAlert } from '@/types/alerts';
import {
  generateJobListingsUrlObject,
  getJobAlertQueryDisplayValues,
} from '@/utils/jobListingHelper';
import { useAnalytics } from '@/utils/useAnalytics';
import cx from 'classnames';
import dayjs from 'dayjs';
import Link from 'next/link';
import React from 'react';

import { Button, Grid, Typography } from '@material-ui/core';

import styles from './JobAlertCard.module.scss';
import EditIcon from './imgs/edit.svg';
import RemoveIcon from './imgs/remove.svg';

interface JobAlertCardProps {
  data: IAlert;
  openDialog: (alert: IAlert) => void;
  onDelete: (id: string) => void;
}

export const JobAlertCard = ({ data, openDialog, onDelete }: JobAlertCardProps) => {
  const track = useAnalytics();

  const { updatedAt, frequency, id, name, query, isDeleted } = data;

  const handleEdit = async () => {
    openDialog(data);
  };

  const handleTitleClick = () => track('Saved job alert title click', {});

  const jobSearchLink = generateJobListingsUrlObject({ ...query, jobAlert: 'Manage' });

  return (
    <div className={cx(styles.container, isDeleted ? styles.hideCard : '')}>
      <Grid container spacing={3}>
        <Grid item md={10} xs={12}>
          <Link
            href={jobSearchLink}
            prefetch={false}
            className={styles.titleLink}
            data-testid="job-alert-search-link"
            onClick={handleTitleClick}
          >
            <Typography
              variant="h5"
              component="h2"
              data-testid="job-alert-name"
              className={styles.title}
            >
              {name}
            </Typography>
          </Link>

          <div data-testid="job-alert-container" className={styles.content}>
            <div className={styles.tagRow}>
              <span>Search filters:</span>
              {getJobAlertQueryDisplayValues(query).map(item => (
                <JobAlertChip key={item} label={item} />
              ))}
            </div>
            {frequency !== 'none' && (
              <div className={styles.tagRow}>
                <span>Frequency:</span>
                <JobAlertChip label={frequency} />
              </div>
            )}
          </div>
        </Grid>
        <Grid item md={2} xs={12} className={styles.alignRight}>
          <Button
            className={styles.button}
            startIcon={<EditIcon width={23} height={21} />}
            onClick={handleEdit}
            data-testid="job-alert-edit-button"
          >
            Edit alert
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item md={9} xs={6}>
          <Button
            className={styles.button}
            startIcon={<RemoveIcon width={13} height={14} />}
            data-testid="job-alert-delete-button"
            onClick={() => {
              onDelete(id);
            }}
          >
            Remove
          </Button>
        </Grid>
        <Grid item md={3} xs={6} className={cx(styles.date, styles.alignRight)}>
          Saved {dayjs(updatedAt).format('DD MMM YYYY')}
        </Grid>
      </Grid>
    </div>
  );
};
